__turbopack_context__.v({
  "content": "NewsListWrapper-module-scss-module__dl-45G__content",
  "descriptionHidden": "NewsListWrapper-module-scss-module__dl-45G__descriptionHidden",
  "title": "NewsListWrapper-module-scss-module__dl-45G__title",
  "titleHidden": "NewsListWrapper-module-scss-module__dl-45G__titleHidden",
});
